<template>
  <div class="promo">
    <FieldInput
      name="promoCode"
      placeholder="Promo code"
      class="promo-field"
      :value="value"
      :touched="touched"
      :onBlur="() => onChange(value, true)"
      :onChange="(event) => onChange(event.target.value, false)"
    />
    <CustomButton :onClick="onSubmit" class="button transparent"
      >Apply</CustomButton
    >
  </div>
</template>
<script>
import CustomButton from "./CustomButton.vue";
import FieldInput from "./FieldInput.vue";

export default {
  name: "promo-code",
  components: {
    CustomButton,
    FieldInput,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    touched: {
      type: Boolean,
      required: true,
    },
    onBlur: {
      type: Function,
      default(event) {
        return event;
      },
    },
    onChange: {
      type: Function,
      default(event) {
        return event;
      },
    },
    onSubmit: {
      type: Function,
      default(event) {
        return event;
      },
    },
  },
};
</script>
